/* ===================
   FILE TYPE SELECTOR
   =================== */

import Globals from './_globals';

export default class FileTypeSelector {
	
	$elem: JQuery;
	fileTypeSelected: string;

	constructor(
		private globals: Globals
	) {
		
		this.$elem = $('#file-type-selector');
		
		// Add the select2
		this.globals.enhancedSelect.doSelect2(this.$elem);
	
		this.bindEvents();
		
	}
	
	bindEvents() {
		
		this.$elem.on('change', (evt: JQueryEventObject) => {
			this.fileTypeSelected = $(evt.currentTarget).val();
			this.$elem.trigger('atum-export-file-type-selected');
		}).change(); // Force the change in case an existing template is being loaded.
	
	}

}


// WEBPACK FOOTER //
// ./assets/js/src/components/export-central/_file-type-selector.ts